import { render, staticRenderFns } from "./EventHighlightsView.vue?vue&type=template&id=4f5c1948"
import script from "./EventHighlightsView.vue?vue&type=script&lang=ts"
export * from "./EventHighlightsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports